module.exports = __webpack_public_path__ + "img/graduate-a-girl.56d8f2fa.jpg";